import {
    ProcessField,
    ServiceProcessFieldTableColumnVM,
} from '@shared/types/process';
import { LngRecord } from '@shared/types/types';
import { normalizeColumnOptions } from './tableFieldColumnUtils';

const emptyLngRecord: LngRecord = { ru: '', kk: '', en: '' };

export function buildProcessFieldFromTableColumn(
    column: ServiceProcessFieldTableColumnVM,
): ProcessField | null {
    if (
        column.fillSourceId !== 'Manual' ||
        !column.manualFieldTypeId
    ) {
        return null;
    }

    return {
        id: column.id,
        typeId: column.manualFieldTypeId,
        options: normalizeColumnOptions(column.options) ?? {},
        name: column.title ?? emptyLngRecord,
        description: emptyLngRecord,
        tooltip: emptyLngRecord,
        unique: false,
        runContext: false,
    } as ProcessField;
}
